import Button from '@/components/Button';

const ControlButtons = () => {
  return (
    <div className="flex items-center gap-2">
      <Button
        type="reset"
        variant="unstyled"
        className="flex-1 text-jb-neutral-700"
      >
        Clear all
      </Button>
      <Button type="submit" variant="candidate-black" className="flex-1">
        Apply
      </Button>
    </div>
  );
};

export default ControlButtons;
